import Iconography from './iconography';

export default Iconography;
